import { ActionDisabledComponent } from './components/action-disabled/action-disabled.component';
import { AlertComponent } from './components/alert/alert.component';
import { AppErrorMessageComponent } from './components/app-error-message/app-error-message.component';
import { AppLockComponent } from './components/app-lock/app-lock.component';
import { AppMatAutocompleteComponent } from './components/app-mat-autocomplete/app-mat-autocomplete.component';
import { AppMatDateTimePickerComponent } from './components/app-mat-date-time-picker/app-mat-date-time-picker.component';
import { AppMatEmailCardComponent } from './components/app-mat-email-card/app-mat-email-card.component';
import { AppMatFaxCardComponent } from './components/app-mat-fax-card/app-mat-fax-card.component';
import { AppMatFormInputComponent } from './components/app-mat-form-input/app-mat-form-input.component';
import { AppMatPhoneCardComponent } from './components/app-mat-phone-card/app-mat-phone-card.component';
import { AppMatSelectComponent } from './components/app-mat-select/app-mat-select.component';
import { AppMatTextAreaComponent } from './components/app-mat-text-area/app-mat-text-area.component';
import { AppMatTextDisplayComponent } from './components/app-mat-text-display/app-mat-text-display.component';
import { BannerComponent } from './components/banner/banner.component';
import { BasicEditorComponent } from './components/basic-editor/basic-editor.component';
import { ContainerComponent } from './components/container/container.component';
import { DateNavigatorComponent } from './components/date-navigator/date-navigator.component';
import { FileIconComponent } from './components/file-icon/file-icon.component';
import { IconPickerComponent } from './components/icon-picker/icon-picker.component';
import { LoadingBarComponent } from './components/loading-bar/loading-bar.component';
import { LoadingComponent } from './components/loading/loading.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { MatContenteditableTextAreaComponent } from './components/mat-contenteditable-text-area/mat-contenteditable-text-area.component';
import { MatDatetimeComponent } from './components/mat-datetime/mat-datetime.component';
import { MaterialSearchBoxComponent } from './components/material-searchbox/material-search-box.component';
import { SearchFilterPipe } from './components/material-searchbox/search-filter.pipe';
import { ModuleDisabledComponent } from './components/module-disabled/module-disabled.component';
import { ProfilePictureComponent } from './components/profile-picture/profile-picture.component';
import { TagComponent } from './components/tag/tag.component';
import { ToastsComponent } from './components/toasts/toasts.component';
import { BackButtonDirective } from './directives-core/back-button.directive';
import { BackgroundColourOpacityDirective } from './directives-core/background-colour-opacity.directive';
import { DragDropDirective } from './directives-core/drag-drop.directive';
import { IdleTimeoutDirective } from './directives-core/idle-timeout.directive';
import { InputFormatterDirective } from './directives-core/input-formatter.directive';
import { InteractiveTextFieldDirective } from './directives-core/interactive-text-field.directive';
import { InvertTextColorDirective } from './directives-core/invert-text-color.directive';
import { MatCheckboxBackgroundColourDirective } from './directives-core/mat-checkbox-background-colour.directive';
import { PermissionRequiredDirective } from './directives-core/permission-required.directive';
import { SpeechToTextDirective } from './directives-core/speech-to-text-directive';
import { TextareaAutosizeDirective } from './directives-core/textarea-autosize.directive';
import { TextareaHidpiRendererDirective } from './directives-core/textarea-hidpi-renderer.directive';
import { TextareaJumptextDirective } from './directives-core/textarea-jumptext.directive';
import { ConfirmationDialogComponent } from './directives/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogDirective } from './directives/confirmation-dialog/confirmation-dialog.directive';
import { MentionDirective } from './mentions/mention.directive';
import { MentionListComponent } from './mentions/mention-list.component';
import { SearchBoxDirective } from './directives/searchbox/searchbox.directive';

export const XMEDICAL_UI_STANDALONE_EXPORTS = [
  // Components
  ActionDisabledComponent,
  AlertComponent,
  AppErrorMessageComponent,
  AppLockComponent,
  AppMatAutocompleteComponent,
  AppMatDateTimePickerComponent,
  AppMatEmailCardComponent,
  AppMatFaxCardComponent,
  AppMatFormInputComponent,
  AppMatPhoneCardComponent,
  AppMatSelectComponent,
  AppMatTextAreaComponent,
  AppMatTextDisplayComponent,
  BannerComponent,
  BasicEditorComponent,
  ConfirmationDialogComponent,
  ContainerComponent,
  DateNavigatorComponent,
  FileIconComponent,
  IconPickerComponent,
  LoadingBarComponent,
  LoadingComponent,
  LoadingSpinnerComponent,
  MatContenteditableTextAreaComponent,
  MatDatetimeComponent,
  MaterialSearchBoxComponent,
  MentionListComponent,
  ModuleDisabledComponent,
  ProfilePictureComponent,
  TagComponent,
  ToastsComponent,
  // Directives
  BackButtonDirective,
  BackgroundColourOpacityDirective,
  ConfirmationDialogDirective,
  DragDropDirective,
  IdleTimeoutDirective,
  InputFormatterDirective,
  InteractiveTextFieldDirective,
  InvertTextColorDirective,
  MatCheckboxBackgroundColourDirective,
  MentionDirective,
  PermissionRequiredDirective,
  SearchBoxDirective,
  SpeechToTextDirective,
  TextareaAutosizeDirective,
  TextareaHidpiRendererDirective,
  TextareaJumptextDirective,
  // Pipes
  SearchFilterPipe,
] as const;

export const XMEDICAL_UI_IMPORTS = [
  ...XMEDICAL_UI_STANDALONE_EXPORTS
] as const;
